// Flow types automatically removed

import { Component } from 'react';
import { BasicSelect } from 'dibs-elements/exports/BasicSelect';
import { Input } from 'dibs-elements/exports/Input';
import { NumberInput } from 'dibs-elements/exports/NumberInput';
const INPUT_SIZE = 'large';
export class DynamicInput extends Component {
    getBasicSelectProps() {
        const {
            dataTn,
            disabled,
            errorMessage,
            hasAnimatedPlaceholder,
            label,
            onChange,
            options,
            placeholder,
            value,
            size,
        } = this.props;
        return {
            dataTn,
            disabled,
            errorMessage,
            hasAnimatedPlaceholder:
                typeof hasAnimatedPlaceholder === 'boolean' ? hasAnimatedPlaceholder : true,
            label,
            ...(onChange
                ? {
                      onChange,
                  }
                : null),
            options,
            placeholder,
            size: size || INPUT_SIZE,
            value,
        };
    }

    getInputProps() {
        const {
            dataTn,
            disabled,
            errorMessage,
            hasAnimatedPlaceholder,
            label,
            onChange,
            placeholder,
            value,
            size,
            leftDecorator,
            rightDecorator,
        } = this.props;
        return {
            dataTn,
            disabled,
            errorMessage,
            hasAnimatedPlaceholder:
                typeof hasAnimatedPlaceholder === 'boolean' ? hasAnimatedPlaceholder : true,
            label,
            leftDecorator,
            ...(onChange
                ? {
                      onChange,
                  }
                : null),
            placeholder,
            rightDecorator,
            size: size || INPUT_SIZE,
            value,
        };
    }

    getNumberInputProps() {
        const {
            dataTn,
            disabled,
            errorMessage,
            hasAnimatedPlaceholder,
            label,
            onChange,
            placeholder,
            value,
            size,
            leftDecorator,
            rightDecorator,
        } = this.props;
        return {
            dataTn,
            disabled,
            errorMessage,
            hasAnimatedPlaceholder:
                typeof hasAnimatedPlaceholder === 'boolean' ? hasAnimatedPlaceholder : true,
            label,
            leftDecorator,
            ...(onChange
                ? {
                      onChange,
                  }
                : null),
            placeholder,
            rightDecorator,
            size: size || INPUT_SIZE,
            value,
        };
    }

    render() {
        const { inputType } = this.props;

        switch (inputType) {
            case 'select': {
                return <BasicSelect {...this.getBasicSelectProps()} />;
            }

            case 'text': {
                return <Input {...this.getInputProps()} />;
            }

            case 'number': {
                return <NumberInput {...this.getNumberInputProps()} />;
            }

            default: {
                return <BasicSelect {...this.getBasicSelectProps()} />;
            }
        }
    }
}
